import Caption from './caption';
import NormalCaption from './normalCaption';

export { Caption, NormalCaption };
